import React from "react";
import PageHeading from "../shared/PageHeading";
import Footer from "../shared/Footer";
import ContactForm from "../sections/contact/ContactForm";
import Spacer from "../shared/Spacer";
import { contact } from "../../data/contact/contact";
import { Button } from "react-bootstrap";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaFacebookMessenger } from "react-icons/fa";

const ContactUs = () => {
	return (
		<div>
			<PageHeading heading="Contact Us" />
			{/* Spacer to push content below the fixed header */}
			<div style={{ height: '30vh' }}></div>
			<div className="content-wrapper" style={{ 
				position: 'relative', 
				zIndex: 10, 
				backgroundColor: 'white',
				minHeight: '100vh'
			}}>
				<div className="text-center">
					<div className="d-flex justify-content-center w-100 mt-5">
					<a
						className="me-3"
						href={`https://wa.me/${contact.phone.replace(/\s/g, "")}`}
						target="_blank"
						rel="noopener noreferrer"
					>
						<Button
							size="lg"
							variant="success"
							className="small-button-font text-white"
						>
							<IoLogoWhatsapp className="me-2" />
							<span>WhatsApp Us</span>
						</Button>
					</a>
					<a
						href="http://m.me/LunaPearlZA"
						target="_blank"
						rel="noopener noreferrer"
					>
						<Button
							size="lg"
							variant="info"
							className="small-button-font text-white"
						>
							<FaFacebookMessenger className="me-2" />
							<span>Message Us</span>
						</Button>
					</a>
				</div>
				<p className="mt-4">- OR -</p>
				</div>
				<ContactForm />
				<Spacer />
				<Footer />
			</div>
		</div>
	);
};

export default ContactUs;
